<template>
  <div>
    <div id="modalTarget" class="control-section; position:relative" style="height: 350px">
      <ejs-dialog
        if="enableModal"
        ref="AddEditCategoryDialog"
        :isModal="isModal"
        :visible="modalState"
        :header="header"
        :target="target"
        :width="width"
        :animationSettings="animationSettings"
        :content="contentTemplate"
        :buttons="buttons"
        :showCloseIcon="true"
        :position="AddEditCategoryDialogPosition"
        cssClass="stage-modal-position"
      >
      </ejs-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { boolean } from "yargs";

import formsCategoryModalHeaderVue from "./forms-category-modal-header.vue";
import formsCategoryModalContentVue from "./forms-category-modal-content.vue";
import { ADD_UPDATE_FORMS_CATEGORY } from "../store";

export default {
  name: "FormsCategoryModal",
  components: {},
  data() {
    return {
      target: "#app",
      width: "50%",
      header() {
        return {
          template: formsCategoryModalHeaderVue,
        };
      },
      contentTemplate() {
        return {
          template: formsCategoryModalContentVue,
        };
      },
      buttons: [{ click: this.handleSaveClick, buttonModel: { content: "Save", isPrimary: true } }],
      isModal: true,
      enableModal: false,
      initialshowModal: false,
      AddEditCategoryDialogPosition: { X: "center", Y: "top" },
      animationSettings: { effect: "None" },

      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      gridPageSettings: { pageSize: 10 },
      editSettings: { allowEditing: true, allowDeleting: true },
    };
  },
  created() {},
  watch: {},
  mounted() {},
  props: {
    showModal: boolean,
    category: Object,
  },
  computed: {
    modalState() {
      return this.showModal;
    },
    getFormValues() {
      const categoryForm = this.$refs.AddEditCategoryDialog.$children[1];
      const { categoryName, categoryOrderId } = categoryForm.$refs;
      return { categoryOrderId, categoryName };
    },
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === "Error" ? "e-toast-danger" : "e-toast-success",
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    handleSaveClick() {
      const category = this.$refs.AddEditCategoryDialog.$children[1].validate();
      if (category) {
        this.saveCategory(category);
        this.hideModal();
      }
    },
    async saveCategory({
      messageId, orderId, message, messageType,
    }) {
      let payload;

      if (messageId) {
        payload = {
          messageId,
          orderId,
          message,
          messageType: messageType || "PublicDocumentType",
        };
      } else {
        payload = {
          orderId,
          message,
          messageType: messageType || "PublicDocumentType",
        };
      }
      await this.$store.dispatch(ADD_UPDATE_FORMS_CATEGORY, payload).catch((error) => {
        this.notify("Error", error.response.data);
      });
    },
    hideModal() {
      this.$refs.AddEditCategoryDialog.hide();
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
.wrap {
  margin: 0 auto;
  width: 240px;
}
</style>
